import React from "react";

const MediaUrl = ({highQuality}) => <p className='italic text-gray-500 pl-2'>URL: <a href={highQuality} target="_blank" >{highQuality}</a></p>

export default MediaUrl
